
import injectionWindow from '../lang/index';
export const HAOTAO_FLAG = 1;
export const PRODUCT_ACCESSORY_CHANNEL = 3;
export const UNION_NAME = '福豆';
export const deliveryWays = [
  {
    label: '工作日／周末／假日均可',
    value: 0,
  }
];
export const healthChannelId = '15';
export const noHeadUnion = 'cea';

export const channelNames = {
  channel2:'优选生活',
  channel3:'生日汇',
  channel15:'健康商城',
  channel18:'图书',
  channel998:'图书',
};

injectionWindow();

export const payTotastNames = {
  noRemainPay:  window.TLang('订单已全额抵扣', 'address'),
  amountRecalculate:  window.TLang('抵扣金额已为您重新计算', 'orderConfirm'),
  rechooseTimeCard:  window.TLang('一个商品只能使用一次次卡', 'orderConfirm'),
  timeOrPointCard:  window.TLang('次卡和点卡支付无法同时使用', 'orderConfirm'),
};
